import { useSearchParams } from "react-router-dom";

export default function useCustomSearchParam(param, deleteParams = []) {
  const [searchParams, setSearchParams] = useSearchParams();

  function searchFn(value) {
    const params = new URLSearchParams(searchParams);

    if (!value) {
      params.delete(param);
      if (deleteParams.length > 0) {
        deleteParams.forEach((val) => params.delete(val));
      }
    } else {
      params.set(param, value);
    }

    if (deleteParams.length > 0) {
      deleteParams.forEach((val) => params.delete(val));
    }

    setSearchParams(params);
  }

  return { searchFn, searchParams, setSearchParams };
}
